import { fetchFromVolatileServer } from "../../utils/fetchFromVolatileServer";

export async function getAllCategoriesByType(
  token: string,
  categoryType: string,
  // lang?: string,
  // defaultLang?: string,
) {
  let url;
  switch (categoryType) {
    case "categories_tiptopf":
      url = `${process.env.BACKEND_HOST}/topf/v1/kategorien`;
      break;
    case "diet_types":
      url = `${process.env.BACKEND_HOST}/topf/v1/ernaehrungsformen`;
      break;
    case "saisons":
      url = `${process.env.BACKEND_HOST}/topf/v1/saisons`;
      break;
    case "cooking_methods":
      url = `${process.env.BACKEND_HOST}/topf/v1/garmethoden`;
      break;
    default:
      console.warn("NOT A VALID CATEGORY: ", categoryType);
      break;
  }

  if (url) {
    // defaultLang !== lang && (url += `?lang=${lang}`);
    try {
      const res = await fetchFromVolatileServer(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) {
        console.error("Response not ok for", url, res.status);
        throw new Error("Response not ok");
      }

      const result = await res.json();
      return result;
    } catch (err) {
      console.error(err);
      return null;
    }
  } else {
    console.warn("No valid category", categoryType);
  }

  return null;
}
